import { Component, Input, Output, EventEmitter, OnInit } from 'ng-metadata/core';
import './title.component.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentTitle
 * @module mw.components.contentDocuments
 *
 * @param {string} [text] - A document title.  This can be an HTML string.
 * @param {string} [documentUrl] - The document url.  If provided this will make the entire title a a clickable href.
 * @param {expression} [on-click] - Angular expression to evaluate on click of the title. $event is the ng-click event.
 *
 * @description
 * `<mw-content-document-title>` provides a means for displaying the title of a content document.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <!-- Using transclusion -->
 *   <mw-content-document-title>My Document Title</mw-content-document-title>
 *
 *   <!-- Using 'text' input binding -->
 *   <mw-content-document-title text="My Document Title"></mw-content-document-title>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-content-document-title',
    template: `
        <a class="mw-content-document-title" data-tracking-event="documentOperation/open" ng-if="::$ctrl.text && $ctrl.documentUrl" ng-href="{{::$ctrl.documentUrl}}" target="_blank" ng-click="$ctrl.handleTitleClick($event);" ng-bind-html="::($ctrl.text | mwSanitizeInvalidHtml | mwLinkyHtml)">
            <ng-transclude></ng-transclude>
        </a>
        <div class="mw-content-document-title" ng-if="::$ctrl.text && !$ctrl.documentUrl" ng-bind-html="::($ctrl.text | mwSanitizeInvalidHtml | mwLinkyHtml)">
            <ng-transclude></ng-transclude>
        </div>
    `,
    legacy: {
        transclude: true
    }
})
export class TitleComponent implements OnInit {
    @Input('<') text: string;
    @Input('<') documentUrl: string;
    @Output() onClick = new EventEmitter<ng.IAngularEvent>();

    constructor() {
        'ngInject';
    }

    ngOnInit() {
    }

    handleTitleClick(event: ng.IAngularEvent) {
        this.onClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/title/title.component.ts